/** Gán nhãn CTGG từ API by-product (`discount-programs/by-product/...`). */
export function labelsFromDiscountProgramApi(program) {
  const name =
    (
      program.name ??
      program.programName ??
      program.discountProgramName ??
      ''
    )
      .toString()
      .trim();

  let code = (
    program.code ??
    program.promotionCode ??
    program.promotionProgramCode ??
    ''
  )
    .toString()
    .trim();

  const id = Number(program.id);
  if (!code && id > 0) {
    code = `CK#${id}`;
  }

  return { code, name };
}

/**
 * Chuẩn hoá promotionProgramCode / promotionProgramName sau GET đơn-hóa đơn hoặc khi hydrate.
 * Sửa dữ liệu cũ: FE trước đây ghi cả description vào promotionProgramCode.
 */
export function normalizePromotionLabelsFromHydrate(row, apiItem = {}) {
  let code = (
    apiItem.promotionProgramCode ??
    row.promotionProgramCode ??
    ''
  )
    .toString()
    .trim();

  let name = (
    apiItem.promotionProgramName ??
    apiItem.promotionProgramsName ??
    apiItem.discountProgramName ??
    row.promotionProgramName ??
    ''
  )
    .toString()
    .trim();

  const pid = Number(
    apiItem.discountProgramId ?? row.discountProgramId ?? apiItem.programId ?? 0,
  );

  const looksLikeEmbeddedDescription =
    code.length >= 36 ||
    (code.split(/\s+/).filter(Boolean).length >= 5 && /\s/.test(code));

  if (!name && code && looksLikeEmbeddedDescription && pid > 0) {
    name = code;
    code = `CK#${pid}`;
  } else if (!name && code) {
    name = code;
  } else if (name && !code && pid > 0) {
    code = `CK#${pid}`;
  }

  row.promotionProgramCode = code;
  row.promotionProgramName = name;
}

/** Text ngắn trên nhãn (ưu tiên mã CK). */
export function getPromotionBadgeText(row) {
  const code = (row.promotionProgramCode || '').trim();
  if (code) {
    return code;
  }
  const name = (row.promotionProgramName || '').trim();
  if (!name) {
    return '';
  }
  return name.length > 22 ? `${name.slice(0, 20)}…` : name;
}

/** Tooltip: tên đầy đủ chương trình */
export function getPromotionTooltipText(row) {
  const name = (row.promotionProgramName || '').trim();
  const code = (row.promotionProgramCode || '').trim();
  if (name && name !== code) {
    return name;
  }
  return name || code || '';
}

export function rowHasPromotionLabel(row) {
  const code = (row.promotionProgramCode || '').trim();
  const name = (row.promotionProgramName || '').trim();
  return !!(code || name);
}
